import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import './Footer.css';

// Image protection handlers
const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
};

const handleDragStart = (e: any) => {
    e.preventDefault();
    return false;
};

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    const renderIcon = (IconComponent: any, size: number) => {
        return React.createElement(IconComponent, { size });
    };

    return (
        <footer className="footer-section">
            <div className="footer-container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <img 
                            src="/logo.jpg" 
                            alt="Studio Z26" 
                            className="footer-logo-image"
                            onContextMenu={handleContextMenu}
                            onDragStart={handleDragStart}
                            style={{ pointerEvents: 'none' }}
                        />
                        <p className="footer-tagline">Cinematic Storytelling</p>
                        <div className="social-icons">
                            <a href="https://wa.me/917908086574" target="_blank" rel="noopener noreferrer" className="social-icon">
                                {renderIcon(FaWhatsapp, 20)}
                            </a>
                            <a href="https://www.facebook.com/share/1BBgSForGb/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                {renderIcon(FaFacebook, 20)}
                            </a>
                            <a href="https://www.instagram.com/studio_z_26/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                {renderIcon(FaInstagram, 20)}
                            </a>
                            <a href="https://www.youtube.com/@studioz2638" target="_blank" rel="noopener noreferrer" className="social-icon">
                                {renderIcon(FaYoutube, 20)}
                            </a>
                        </div>
                    </div>

                    <div className="footer-links-grid">
                        <div className="footer-column">
                            <h3>EXPL0RE</h3>
                            <a href="/">Home</a>
                            <a href="#about">About</a>
                            <a href="#services">Packages</a>
                            <a href="#testimonials">Testimonials</a>
                        </div>

                        <div className="footer-column">
                            <h3>S0CIAL</h3>
                            <a href="https://www.instagram.com/studio_z_26/" target="_blank" rel="noopener noreferrer">Instagram</a>
                            <a href="https://wa.me/917908086574" target="_blank" rel="noopener noreferrer">Whatsapp</a>
                            <a href="https://www.pinterest.com/studioz26/" target="_blank" rel="noopener noreferrer">Pinterest</a>
                            <a href="https://www.facebook.com/share/1BBgSForGb/" target="_blank" rel="noopener noreferrer">Facebook</a>
                        </div>

                        <div className="footer-column">
                            <h3>C0NTACT</h3>
                            <a href="tel:+917908086574">+91 79080 86574</a>
                            <a href="mailto:quick.studioz26@gmail.com">quick.studioz26@gmail.com</a>
                            <a 
                                href="https://www.google.com/maps?q=23.386728599999998,88.5009809" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="address-link"
                            >
                                <p className="address">
                                    Kabiguru road (panchmatha more) <br />Krishnanagar, Nadia 741102
                                </p>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-copyright">
                        © {currentYear} Studio Z26. All rights reserved.
                    </div>
                    <div className="footer-legal">
                        <a href="#privacy">Privacy Policy</a>
                        <a href="#terms">Terms of Service</a>
                    </div>
                    <div className="footer-designer">
                        Designed by <a href="https://palhawk.in" target="_blank" rel="noopener noreferrer">PalHawk</a>
                    </div>
                </div>

                <motion.div
                    className="footer-big-text"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    STUDIO Z26
                </motion.div>
            </div>
        </footer>
    );
};

export default Footer;
